import { pandaHelloImage } from '@app/assets';

export function BackgroundImage() {
  return (
    <img
      src={pandaHelloImage}
      alt="panda hello"
      className="absolute bottom-0 left-1/2 w-[410px] -translate-x-1/2"
    />
  );
}
